import Tabs from './src/tabs';
import TabPane from './src/tab-pane';

module.exports = {
    Tabs,TabPane
}


// WEBPACK FOOTER //
// ./src/components/tabs/index.js